import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  details: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
  },
  wrapper: {
    alignItems: 'center',
    padding: 16,
    backgroundColor: neutrals.white,
    borderRadius: 16,
    width: 168,
    height: 168,
  },
  wrapperLoader: {
    alignItems: 'center',
    padding: 16,
    width: 168,
    height: 168,
  },
  qrCodeWrapper: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: 8,
    paddingTop: 16,
  },
  title: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  mainTitle: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 31,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.graphite,
  },
  titleWrapper: {
    alignItems: 'center',
    gap: 11,
  },
});
